import * as zod from 'zod';

export const NoGripperConfiguration = zod.object({
  kind: zod.literal('NoGripper'),
  name: zod.string().default('No gripper'),
});

export type NoGripperConfiguration = zod.infer<typeof NoGripperConfiguration>;
